import { ActionPlanExistsResponse } from 'api/dto/new/ActionPlan/ActionPlanExists.dto';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'actionPlans';

export namespace ActionPlansState {
  export type Domain = {
    exists: Resource<ActionPlanExistsResponse | null>;
  };

  export const INITIAL_DOMAIN: Domain = {
    exists: Resource.createPendingResource(null),
  };
}

export type ActionPlansState = {
  actionPlans: ActionPlansState.Domain;
};
